(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-xwf-reviews]').forEach((carousel) => {
      if (carousel.dataset.xwfReady === 'true') return;
      carousel.dataset.xwfReady = 'true';

      const viewport = carousel.querySelector('[data-xwf-viewport]');
      const cards = [...carousel.querySelectorAll('[data-xwf-card]')];
      const previous = carousel.querySelector('[data-xwf-previous]');
      const next = carousel.querySelector('[data-xwf-next]');
      const dots = carousel.querySelector('[data-xwf-dots]');
      if (!viewport || cards.length < 2 || !previous || !next || !dots) return;

      let step = 1;
      let maxIndex = 0;
      let frame = 0;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const currentIndex = () => Math.min(maxIndex, Math.max(0, Math.round(viewport.scrollLeft / step)));

      const updateControls = () => {
        const index = currentIndex();
        previous.disabled = index === 0;
        next.disabled = index === maxIndex;
        [...dots.children].forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const goTo = (index) => {
        viewport.scrollTo({
          left: Math.min(maxIndex, Math.max(0, index)) * step,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      const measure = () => {
        step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
        if (step <= 0) return;
        const visibleCards = Math.max(1, Math.round(viewport.clientWidth / step));
        maxIndex = Math.max(0, cards.length - visibleCards);
        dots.replaceChildren();

        for (let index = 0; index <= maxIndex; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'xwf-reviews__dot';
          dot.setAttribute('aria-label', dots.dataset.xwfDotLabel.replace('#', String(index + 1)));
          dot.addEventListener('click', () => goTo(index));
          dots.append(dot);
        }

        updateControls();
      };

      previous.addEventListener('click', () => goTo(currentIndex() - 1));
      next.addEventListener('click', () => goTo(currentIndex() + 1));
      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        goTo(currentIndex() + (event.key === 'ArrowRight' ? 1 : -1));
      });
      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateControls);
      }, { passive: true });

      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(viewport);
      else window.addEventListener('resize', measure);
      measure();
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
